import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  public_access_token: null,
  billingDepositsTableRows: 10,
  billingPaymentsTableRows: 10,
  billingInvoicesTableRows: 10,
  latest_alerts_expanded: false,
  cookies_status: null,
}

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setPublicAccessToken: (state, action) => {
      state.public_access_token = action.payload.public_access_token
    },
    setBillingDepositsTableRows: (state, action) => {
      state.billingDepositsTableRows = action.payload.billingDepositsTableRows
    },
    setBillingPaymentsTableRows: (state, action) => {
      state.billingPaymentsTableRows = action.payload.billingPaymentsTableRows
    },
    setBillingInvoicesTableRows: (state, action) => {
      state.billingInvoicesTableRows = action.payload.billingInvoicesTableRows
    },
    setLatestAlertsExpanded: (state, action) => {
      state.latest_alerts_expanded = action.payload.latest_alerts_expanded
    },
    setCookiesStatus: (state, action) => {
      state.cookies_status = action.payload.cookies_status
    },
    settingsReset: () => {
      return { ...initialState }
    }
  }
})

export const { 
  setPublicAccessToken,
  setBillingDepositsTableRows,
  setBillingPaymentsTableRows,
  setBillingInvoicesTableRows,
  setLatestAlertsExpanded,
  setCookiesStatus,
  settingsReset,
} = settingsSlice.actions

export default settingsSlice.reducer